import cx from "classnames";
import React, { useState } from "react";
import { Button } from "reactstrap";

import { TableBlock } from "../../../types";
import { Props } from "../types";
import { extractHumanReadableText } from "../util";
import { Editing } from "./Editing";
import { Table as InnerTable } from "./Table";

export const TABLE_SELECT_CONFIRMATION = [
  "Are you sure you want to select an entire table as support?",
  "It is more desireable to select a specific cell.",
].join(" ");

type TableProps = Props<TableBlock> &
  Readonly<{
    previewImage: React.ReactElement;
  }>;

export const Table = ({
  block,
  blocks,
  confirmTableSelection,
  disableTableSelectionConfirmation,
  fontInformation,
  id,
  onAddCorrections,
  onSelectBlock,
  pages,
  previewImage,
  referencesLink,
  selected,
  selectedCell,
  setShowReferences,
}: TableProps) => {
  const [mouseWithin, setMouseWithin] = useState(false);
  const [editing, setEditing] = useState(false);
  if (!!onAddCorrections && editing) {
    return (
      <Editing
        block={block}
        onCancel={() => {
          setEditing(false);
        }}
        onSave={(newCorrection: string) => {
          setEditing(false);
          onAddCorrections(block.id, newCorrection);
        }}
        onSelectBlock={onSelectBlock}
        pages={pages}
        previewImage={previewImage}
      />
    );
  }
  return (
    <div
      className={cx("block", "pt-3", "pb-3", {
        editable: !!onAddCorrections,
        "p-3": !onAddCorrections,
        selected,
        within: mouseWithin,
      })}
      onClick={e => {
        e.preventDefault();
        if (mouseWithin || !onSelectBlock) {
          return;
        }
        if (confirmTableSelection && !window.confirm(TABLE_SELECT_CONFIRMATION)) {
          return;
        }
        disableTableSelectionConfirmation();
        onSelectBlock(block.id, extractHumanReadableText(block.element), e.ctrlKey);
      }}
    >
      {!!onAddCorrections && (
        <Button
          className="btn-edit"
          color="link"
          onClick={e => {
            e.stopPropagation();
            setEditing(true);
          }}
          title="Edit"
        >
          <i className="fa fa-edit" />
          <span className="sr-only">Edit</span>
        </Button>
      )}
      <InnerTable
        block={block}
        blocks={blocks}
        fontInformation={fontInformation}
        id={id}
        onSelectBlock={onSelectBlock}
        selected={selected}
        selectedCell={selectedCell}
        setMouseWithin={setMouseWithin}
        setShowReferences={setShowReferences}
      />
      {referencesLink}
    </div>
  );
};
Table.displayName = "Table";
